<template>
  <el-dialog
    title="机构二维码"
    :visible.sync="visible"
    append-to-body
    v-dialogDrag
    width="400px"
    top="30px"
    :close-on-click-modal="false"
  >
    <el-form
      :model="form"
      label-position="right"
      label-width="400px"
      style="display: flex; justify-content: space-around"
    >
      <el-row :gutter="10">
        <!-- <el-col>
        <template style="text-align:center">这里显示机构名称</template>
      </el-col> -->
        <el-col>
          <template style="text-align: center"
            ><img
              :src="imgsrc"
              class="avatar"
              style="height: 400px; width: 400px"
          /></template>
        </el-col>
        <!-- <el-col>
        <template>使用华燕拆车小程序绑定机构（内部系统，请勿泄露）</template>
      </el-col> -->
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button type="canale" @click="visible = false">关闭</el-button>
    </span>
  </el-dialog>
</template>
  
  <script>
export default {
  props: ["item"],
  data() {
    return {
      visible: false,
      activeNames: "1",
      imgsrc: "",
      form: {},
      data: [],
    };
  },
  watch: {
    item: {
      handler: function (v) {
        this.$get("Organization/GetGenerateQrCode", {
          Id: v.Id,
          StaName: v.StaName,
        }).then((r) => {
          this.imgsrc = "data:image/jpeg;base64," + r.Result.Code;
        });
        this.activeNames = "1";
        this.visible = true;
      },
    },
  },
  methods: {},
};
</script>
  
  <style>
</style>